import {PRERERENCES} from '../../constants';

export const preferencesAction = (preferences) => {
    localStorage.setItem('preferences',JSON.stringify(preferences));
    return {
        type: PRERERENCES,
        preferences
    };
};
